import React, { createContext, useReducer, useContext } from "react";
import { showCartToast } from "../utils/cartToastManager";

const initialState = {
  cartItems: [],
};

function cartReducer(state, action) {
  switch (action.type) {
    case "SET_CART_ITEMS":
      return { ...state, cartItems: action.payload };

    default:
      return state;
  }
}

const CartContext = createContext();

export const CartProviderContent = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, initialState);

  return <CartContext.Provider value={{ state, dispatch, showCartToast }}>{children}</CartContext.Provider>;
};

export const CartProvider = ({ children }) => {
  return <CartProviderContent>{children}</CartProviderContent>;
};

export const useCart = () => useContext(CartContext);
